// frontend/src/components/ColorAdminShell.tsx
import { PropsWithChildren, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import './shell.css';
import '../styles/layout-override.css';
import '../components/sidebar-width.css';
import '../styles/sidebar-width.css';
import '../styles/header-fixes.css';

type Props = PropsWithChildren<{ title?: string }>;

export default function ColorAdminShell({ title, children }: Props) {
  // Fija el título y aplica una marca al <body> mientras esté montado el layout.
  useEffect(() => {
    if (title) document.title = title;

    document.body.classList.add('with-sidebar');
    // Por si llegara con estilos residuales de otras pantallas:
    document.body.classList.remove('without-sidebar');

    return () => {
      document.body.classList.remove('with-sidebar');
    };
  }, [title]);

  return (
    <div id="app" className="app">
      {/* Link accesible para saltar al contenido */}
      <a href="#content" className="visually-hidden-focusable">Saltar al contenido</a>

      <Header />

      <div className="app-body">
        <Sidebar />

        {/* Contenido pegado al sidebar (sin huecos) */}
        <main id="content" className="app-content" role="main" aria-label="Contenido principal">
          <div className="container-fluid px-0">
            <div className="content-inner">
              {children}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
